import React from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/EmployeeLogin.css'; // Optional: style each login page

const EmployeeLogin = () => {
  const { serviceId } = useParams();

  const serviceNames = {
    astrology: 'Astrology',
    law: 'Law',
    'cs-projects': 'CS Projects',
    homeopathy: 'Homeopathy',
    civil: 'Civil Works'
  };

  const serviceName = serviceNames[serviceId] || 'Unknown Service';

  return (
    <div className="employee-login-page">
      <Link to="/" className="back-link">← Back to Home</Link>
      <h2>{serviceName} - Employee Login</h2>
      <form>
        <input type="text" placeholder="Username" required />
        <input type="password" placeholder="Password" required />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default EmployeeLogin;
